export default "/images/vendor/flag-icons/flags/1x1/is.svg?980b7dfef62be73a4122963f044ba29b";